import type { TaskResult } from "../types";

export async function gradeProject5(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Hoja "Principales Patrocinadores" protegida
  let protegida = false;
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem(
      "Principales Patrocinadores"
    );
    hoja.protection.load("protected");
    await context.sync();
    protegida = hoja.protection.protected;
  });
  results.push({ taskId: 1, passed: protegida });

  // Tarea 2: Formato condicional + ordenar por color → A3:A6 = BottomsUp, Marine Swimwear, SCUBA-wear, Women's Divewear
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Expositores");
    const rango = hoja.getRange("A3:A6");
    rango.load("values");
    await context.sync();

    const esperado = [
      "BottomsUp",
      "Marine Swimwear",
      "SCUBA-wear",
      "Women's Divewear",
    ];
    const reales = rango.values.map((r) => r[0]);
    const passed = esperado.every((v, i) => reales[i] === v);
    results.push({ taskId: 2, passed });
  });

  // Tarea 3: =AHORA() en G1 de Horario de Sesiones
  await Excel.run(async (context) => {
    const hoja = context.workbook.worksheets.getItem("Horario de Sesiones");
    const cel = hoja.getRange("G1");
    cel.load("formulas");
    await context.sync();

    const ok = (cel.formulas[0][0] || "").toUpperCase() === "=NOW()";
    results.push({ taskId: 3, passed: ok });
  });

  // Tarea 4: Quitar duplicados en "Expositores"
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem("Expositores");
    const range = sheet.getRange("A3:A36");
    range.load("values");
    await context.sync();

    const arr = range.values.map((r) => (r[0] || "").toString().trim());
    const todasLlenas = arr.every((v) => v !== "");
    const sinDuplicados = new Set(arr).size === arr.length;
    results.push({ taskId: 4, passed: todasLlenas && sinDuplicados });
  });

  // Tarea 5: Gráfico dinámico filtrado (columna agrupada + Jueves + Marketing/Ventas)
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem("Horario Diario");
    const charts = sheet.charts;
    charts.load("items/chartType");

    const rA4 = sheet.getRange("A4").load("values");
    const rA5 = sheet.getRange("A5").load("values");
    const rA11 = sheet.getRange("A11").load("values");
    const rB18 = sheet.getRange("B18").load("values");
    await context.sync();

    const hasClustered = charts.items.some(
      (c) => c.chartType === Excel.ChartType.columnClustered
    );

    const cellsOK =
      rA4.values[0][0] === "Jueves" &&
      rA5.values[0][0] === "Marketing" &&
      rA11.values[0][0] === "Ventas" &&
      rB18.values[0][0] === 11;

    results.push({ taskId: 5, passed: hasClustered && cellsOK });
  });

  return results;
}
